import React, { Dispatch, SetStateAction } from 'react';
import { Button, Modal } from 'tea-component';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import igdbIcon from '@intelligence/assets/svg/gameInfo/igdb.svg';

import './index.scss';

interface IMoreReleaseDateModal {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  content: React.ReactElement;
}

function MoreLanguagesModal({ visible, setVisible, content }: IMoreReleaseDateModal) {
  const { formatMessage } = useIntlExtend();

  const handleClose = () => {
    setVisible?.(false);
  };

  return (
    <Modal
      visible={visible}
      onClose={handleClose}
      caption={
        <div className="dbi-languages-show-more-modal-title">
          <img className="dbi-languages-title-img" src={igdbIcon}></img>
          {formatMessage({ id: 'dbi_game_languages' })}
        </div>
      }
    >
      {/* 语言内容展示 */}
      <div className="dbi-languages-show-more-modal-content">{content}</div>
      {/* 关闭按钮 */}
      <div className="dbi-languages-show-more-modal-footer">
        <Button type="primary" onClick={handleClose}>
          {formatMessage({ id: 'dbi_close' })}
        </Button>
      </div>
    </Modal>
  );
}

export default MoreLanguagesModal;
